import styled from 'styled-components'

import tesouraImg from '../../assets/tesoura.png'

export const Content = styled.div`
    margin-left: 250px;
    padding: 1px 16px;

    .new {
        display: flex;
        align-items: center;
        justify-content: center;

        float: right;
        margin-bottom: 15px;
        background: #83bf02;
        padding: 10px;
        border-radius: 5px;
        text-decoration: none;
        border: 0;
        font-weight: 600;
        color: #fff;

        svg {
            margin-right: 5px;
        }

        transition: filter 0.5s;

        &:hover {
            filter: brightness(0.8);
        }
    }

    .header-options {
        display: flex;
        flex-direction: column;

        border-radius: 10px;
        padding: 20px;
        margin-top: 10px;
        margin-bottom: 5px;

        background: #F1F3F5;
        width: 100%;

        .minhas-questoes {
            margin-bottom: 20px;
            width: 100%;

            display: flex;
            align-items: center;
            justify-content: start;
            flex-direction: row;
            gap: 50px;

            p {
                font-size: 14px;
                font-weight: 600;
                color: #343a40;
            }

            .box-check {
                display: flex;
                align-items: center;
                gap: 20px;

                .box {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    input {
                        margin-right: 10px;
                    }
                }
            }

            .box-buttons {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;

                .btn-tipo {
                    width: 140px;
                    background: #FFF;
                    color: #111;
                    padding: 5px 10px;
                    border: 0;
                    border-radius: 25px;
                    text-transform: uppercase;
                    
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: row;

                    &:hover,
                    &:focus-visible{
                        background: #010883;
                        color: #83bf02;
                    }
                }
                
            }
        }

        .minhas-questoess{
            font-size: 13px;
            margin-top: 30px;
            margin-bottom: 20px;
            width: 100%;

            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: row;
            gap: 10px;

            .box-filtro {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .box-buttons {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;

                .sub-box-btn{
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    label {
                        color: #111;
                    }

                    .btn-filter {
                        margin-right: 5px;

                        background: #EE8523;
                        color: #FFF;
                        border: 0;
                        border-radius: 50%;
                        padding: 5px;

                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .btn-rotate {
                        margin-right: 5px;

                        background: #35ABFC;
                        color: #FFF;
                        border: 0;
                        border-radius: 50%;
                        padding: 5px;

                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }

                
            }
        }

        .box-categorys {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          

          select {
            width: 200px;
            height: 30px;
            margin-bottom: 20px;
            padding-left: 5px;
            border: none;
          }

          .assunto {
            width: 200px;
            height: 30px;
          }

          .box-search {
            display: flex;

            .assunto-input {
                width: 180px;
                height: 30px;
                border: 0;
                padding-left: 5px;
            }
            
            .btn-search-question {
                background-color: #fff;
                border: 0;
                margin-bottom: 20px;

                display: flex;
                align-items: center;
                justify-content: center;
                padding-right: 10px;
            }
          }
          
        }

        .btn-search {
            margin: 15px 0;
            width: 120px;
            //max-width: 100px;
            background: #181c2e;
            color: #fff;
            border: none;
            border-radius: 5px;
            padding: 8px;
            font-size: 15px;
        }
            
    }

    .container {
        display: flex;
        flex-direction: column;

        border-radius: 10px;
        padding: 20px;
        margin-bottom: 10px;

        /* .header-options {
            background: #F1F3F5;
            width: 100%;
            
        } */

        .quatidade-questoes {
            margin-bottom: 20px;
            display: flex;
            
        }

        form {
            display: flex;
            flex-direction: column;

            .box-question-answer {
                display: flex;
                flex-direction: column;
                width: 100%;

                .box-answer {
                    display: flex;
                    gap: 10px;
                    flex-direction: row;

                    .answer {
                        display: flex;
                        gap: 3px;
                    }
                }

                .btn-search {
                    margin: 15px 0;
                    width: 100%;
                    background: #181c2e;
                    color: #fff;
                    border: none;
                    border-radius: 5px;
                    padding: 8px;
                    font-size: 15px;
                }
            }
        }

        .btn-search {
            margin: 15px 0;
            width: 500px;
            height: 40px;
            background: #181c2e;
            color: #fff;
            border: none;
            border-radius: 5px;
            padding: 8px;
            font-size: 15px;
        }

        textarea{
          margin-bottom: 20px;
          height: 100px;
          padding: 10px;
        }

        input {
            margin-bottom: 10px;
            padding: 10px;
        }

        

        label {
            margin-bottom: 10px;
        }

        ul {
            list-style: none;
            margin-top: 20px;

            .row {
                display: flex;
                gap: 10px;
                margin-bottom: 5px;
                background-color: #ecf0f1;
                width: 100%;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: start;
                //padding: 0 20px;

                .mark-number {
                    background-color: #bdc3c7;
                    width: 10px;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .row2 {
                display: flex;
                gap: 10px;
                margin-bottom: 5px;

                .mark-row22{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 5px;
                }
                
                .mark-row2 {
                    font-weight: 600;

                    
                }
            }

            hr {
                margin: 10px 0;
            }

            .box-alternativas {
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    justify-content: start;
                    margin-left: 0px;
                    margin-bottom: 10px;
                    width: 100%;
                    //display: grid;
                    
                    
                    .line-alternativa {
                        display: flex;
                        align-items: start;
                        gap: 15px;

                        margin-top: 50px;

                        /* justify-content: flex-start;
                        align-items: flex-start;
                        margin-top: -30px; */
                        
                        padding: 1px;
                        width: 100%;
                        
                        /* p{
                            display: flex;
                            margin-right: 5px;
                        } */

                            .box-option-text {
                                display: flex;
                                align-items: start;
                                justify-content: start;
                                gap: 10px;

                                .btn-alternative {
                                    border: 1px solid #262F40;
                                    border-radius: 50%;
                                    background-color: #FFF;
                                    padding: 10px 12px;
                                    margin-right: 5px;

                                    display: flex;
                                    align-items: center;
                                    justify-content: center;

                                    font-size: 13px;
                                    font-weight: 600;

                                    &:focus {
                                        background-color: #262F40;
                                        border: 1px solid #262F40;
                                        color: #FFF;
                                        padding: 10px 12px;
                                        margin-right: 5px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;

                                        font-size: 13px;
                                        font-weight: 600;
                                    }
                                }

                                .text-alternative{
                                    width: 100%;
                                    display: flex;   
                                }

                                .cut {
                                    text-decoration: line-through;
                                }

                                .text-alternative.cut {
                                    text-decoration: line-through;
                                }

                            }

                        

                        .incorreto {
                            /* text-decoration: line-through; */
                        }

                        .incorreto,
                        .nIncorreto {
                            display: flex;
                            justify-content: center;
                            padding: 0.125rem;
                            font-size: 16px;
                            margin-top: 18px;

                            /* &:focus-visible,
                            &:hover {
                                text-decoration: line-through;
                                //opacity: 0.7;
                                //background-color: rgba($blue, 0.1);
                            } */
                        }

                        .line-alternativa2 {
                            display: flex;
                            justify-content: flex-start;
                            align-items: flex-start;
                            gap: 1rem;
                            padding: 1rem;
                            width: 100%;

                            .incorreto2 {
                                /* text-decoration: line-through; */
                            }

                            .incorreto2,
                            .nIncorreto2 {
                                display: flex;
                                justify-content: center;
                                padding: 0.125rem;
                                font-size: 16px;
                                margin-top: 18px;

                                /* &:focus-visible,
                                &:hover {
                                    text-decoration: line-through;
                                    //opacity: 0.7;
                                    //background-color: rgba($blue, 0.1);
                                } */
                            }

                    }

                    .btn-tesoura{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: transparent;
                            margin-top: 10px;

                            border: 0;
                            
                            p {
                                color: #111;
                                
                            }

                            strong {
                                color: #111;
                            }

                            .letra-contem{
                                display: flex;
                                
                                border: 1px solid #010883;
                                background: #FFF;
                                font-weight: 500;
                                color: #010883;
                                border-radius: 50%;
                                
                                padding: 2px 5px;
                                margin-left: 5px;
                            }

                            .letra-contem2 {
                                display: flex;
                                
                                border: 1px solid #010883;
                                color: #FFF;
                                background: #010883;
                                border-radius: 50%;
                                
                                padding: 2px 5px;
                                margin-left: 5px;
                            }

                            
                            
                        }


                        /* .taskComplete,
                        .taskIncomplete {
                            display: flex;
                            justify-content: left;
                            width: 100%;
                            transition: text-decoration 0.5s ease-out, color 0.5s ease-out;
                        }

                        .taskComplete {
                            text-decoration: line-through;
                        } */
                        
                        /* border: 1px solid $gray-400;
                        border-radius: $br-1;
                        background-color: $gray-500; */

                        /* margin: 2px 0;
                        display: flex;
                        align-items: start;
                        justify-content: start;
                        flex-direction: row;
                        gap: 10px;
                        width: 100%;

                        transition: 0.32s; */

                        /* .btn-tesoura{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: transparent;

                            strong {
                                color: #111;
                            }
                        } */

                        .alternativa {
                            display: flex;
                            align-items: start;
                            justify-content: start;
                            margin-top: 18px;
                            width: 100%;
                        }

                        /* &:hover{
                            
                            &::before{
                                content: url(${tesouraImg});
                                display: inline-block;
                                width: 15px;
                                height: 15px;
                                margin-right: 20px;
                                background: transparent;

                                transition:  .12s ease-out, opacity .06s ease-out;
                            }
                        } */
                        
                    }

                    .btn-selecao {
                        border: 0;
                        margin-left: 10px;
                        margin-top: 10px;
                    }

                    .btn-response {
                        margin: 10px 0;
                        margin-top: 40px;

                        background-color: #262F40;
                        color: #FFF;
                        padding: 10px;
                        border: 0;
                        border-radius: 5px;
                        font-size: 13,5px;
                        font-weight: 600;
                    }

                    .box-btn-adm{
                        display: flex;
                        gap: 10px;
                    }

                    .box-button-question {
                       //margin: 20px 0;
                        margin-top: 20px;
                        margin-bottom: 30px;
                        background-color: #ecf0f1;
                        width: 100%;
                        padding: 10px;

                        display: flex;
                        align-items: start;
                        justify-content: start;
                        flex-direction: column;

                        /* .line-color {
                            background: #010883;
                            width: 100%;
                            height: 5px;
                        } */

                        .box-options-question{
                            //margin-top: -15px;
                            display: flex;
                            align-items: start;
                            justify-content: space-around;
                            width: 100%;
                            flex-direction: row;
                            padding: 10px;

                            .btn-options-question {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                flex-direction: row;
                                width: 100%;
                                background: transparent;
                                color: #111;
                                border: 0;
                                
                                //transition: 0.5s;

                                /* &:hover{
                                    background: #ccc;
                                    //width: 100%;
                                    padding: 10px;
                                } */
                            }
                        }

                    
                }

                .comment{
                        //margin-left: 20px;
                        
                        margin-top: -30px;
                        background: #ECF0F1;
                        width: 100%;
                        padding: 10px 10px;

                        display: flex;
                        align-items: start;
                        justify-content: start;
                        flex-direction: column;
                        
                    }

            }

            section {
                display: flex;
                align-items: start;
                justify-content: center;
                flex-direction: column;
                width: 100%;

                .alt-btn {
                    background-color: #FFF;
                    border: 1px solid #010883;
                    border-radius: 50%;
                    color: #010883;
                    width: 30px;
                    height: 30px;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:focus {
                        background-color: #010883;
                        border: 0;
                        color: #FFF;
                    }

                    
                }

                .box-question {
                    margin: 20px 0;
                    width: 100%;
                }

                

                ul {
                    margin-left: 10px;

                    li {
                        margin: 10px 0;
                    }
                }

                

                .conteiner-content {
                    width: 100%;
                    display: flex;
                    align-items: start;
                    justify-content: start;
                    flex-direction: column;

                    .btn-close {
                        position: absolute;
                        margin: -40px 0;
                        cursor: pointer;
                    }

                    .container-comments-question {
                        display: flex;
                        align-items: start;
                        justify-content: start;
                        flex-direction: column;
                        width: 100%;

                        .box-comments {
                            display: flex;
                            flex-direction: column;
                            width: 100%;
                            gap: 10px;
                            margin-top: 20px;
                            width: 100%;
                            background: #FFF;
                            padding: 5px;
                            border: 0;
                            border-radius: 5px;

                            .box-comment-info {
                                display: flex;
                                flex-direction: row;
                            }

                            p {
                                font-size: 15px;
                            }
                        }
                    }

                    .container-comments {
                        display: flex;
                        align-items: start;
                        justify-content: start;
                        flex-direction: column;

                        margin-top: 20px;
                        width: 100%;

                        .text-comment {
                            width: 100%;
                            resize: none;
                            padding: 10px;
                            font-size: 15px;
                            border: 0;
                            border-radius: 10px;
                            outline: none;
                        }
                    }
                }

                
            }

            
        }
    }

    table {
        border: 1px solid #ccc;
        margin: 0;
        padding: 0;
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;

        /* caption {
            font-size: 10px;
            margin: 5px 0 10px;
        } */

        tr {
            background: #f8f8f8;
            border: 1px solid #ddd;
        }

        th {
            padding: 5px;
            align-items: center;
            font-size: 16px;
        }

        td {
            padding: 10px;
            text-align: center;

            .action {
                border: 0;
                padding: 6px;
                border-radius: 5px;
                display: inline-block;
                margin-right: 3px;

                svg {
                    vertical-align: middle;
                }
            }

            .badge {
                padding: 3px;
                border-radius: 3px;
                color: #fff;
            }
        }
    }

    @media(max-width: 1200px){
        margin-left: 250px;
        padding: 1px 16px;
        //margin-left: 0;

        .header-options{
            .minhas-questoes{
                display: grid;
                grid-template-columns: repeat(3, 1fr);

                .box-check {
                    display: grid;
                    align-items: start;
                    justify-content: start;
                    grid-template-columns: repeat(3, 1fr);
                }

                .box-buttons {
                    width: 100%;
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                }
            }
            
            .box-categorys {
                /* display: grid;
                align-items: start;
                justify-content: start;
                grid-template-columns: repeat(3, 1fr);
                gap: 10px; */

                display: grid;
                grid-template-columns: repeat(2, 1fr);
            }
        }
    }

    @media(max-width:700px){
        margin-left: 0;
        

        .header-options{

            .minhas-questoes{
                display: grid;
                grid-template-columns: repeat(1, 1fr);

                .box-check {
                    display: grid;
                    align-items: start;
                    justify-content: start;
                    grid-template-columns: repeat(2, 1fr);
                }

                .box-buttons {
                    width: 100%;
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                }
            }
            
            .box-categorys {
                display: grid;
                grid-template-columns: repeat(2, 1fr);

            }
        }

        table {
            border: 0;

            thead {
                border: none;
                height: 1px;
                margin: -1px;
                overflow: hidden;
                padding: 0;
                position: absolute;
                width: 1px;
            }

            tr {
                border-bottom: 3px solid #ddd;
                display: block;
                margin-bottom: 10px;
            }

            td {
                border-bottom: 1px solid #ddd;
                display: block;
                font-size: 16px;
                text-align: right;

                
            }

            td::before{
                content: attr(data-label);
                float: left;
                font-weight: bold;
            }
        }
    }
`